import React from 'react';
import './AIProcess.css';

const AIProcess = () => {
  return (
    <section className="ai-process-section">
      <div className="container">
        <div className="section-header-new">
          <h2>How AI Transforms Your Customer Interactions</h2>
          <p>From first contact to conversion, our AI handles every step</p>
        </div>
        <div className="process-flow">
          <div className="process-step">
            <div className="step-visual">
              <i className="fas fa-phone"></i>
            </div>
            <div className="step-content">
              <h3>Customer Calls & Messages</h3>
              <p>The AI receptionist answers instantly and understands customer needs through natural conversation, whether it's a phone call or website chat.</p>
            </div>
          </div>
          <div className="process-arrow">
            <i className="fas fa-arrow-right"></i>
          </div>
          <div className="process-step">
            <div className="step-visual">
              <i className="fas fa-route"></i>
            </div>
            <div className="step-content">
              <h3>Intelligent Routing</h3>
              <p>Calls and messages are smartly routed—appointments get scheduled, inquiries answered, and sales leads qualified automatically.</p>
            </div>
          </div>
          <div className="process-arrow">
            <i className="fas fa-arrow-right"></i>
          </div>
          <div className="process-step">
            <div className="step-visual">
              <i className="fas fa-sync"></i>
            </div>
            <div className="step-content">
              <h3>Seamless Integration</h3>
              <p>All interactions sync with your CRM, update your calendar, and provide key insights for business growth.</p>
            </div>
          </div>
          <div className="process-arrow">
            <i className="fas fa-arrow-right"></i>
          </div>
          <div className="process-step">
            <div className="step-visual">
              <i className="fas fa-brain"></i>
            </div>
            <div className="step-content">
              <h3>Continuous Improvement</h3>
              <p>Your AI agents keep improving with ongoing learning, feedback, and monthly optimizations.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AIProcess;
